<template>
    <app-wrapper>
        <app-header medium-max-width="max-w-1000" :is-hidden-menu="true">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto text-center">
                        <h2 class="mb-1 mt-0 md:text-4xl">Customize Your Extra Cash</h2>
                        <span class="text-gray-500">Choose how much extra cash you’d like to receive and review your updated loan terms.</span>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">

            <template #main>

                <AppBoxContent 
                    class="my-2"
                    width="full" 
                    rounded="lg"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    <Range
                        v-model.number="cashBackAmount"
                        title="Select Extra Cash Amount"
                        description="This will be added to your loan balance"
                        :min="minCashBack"
                        :max="effectiveMaxCashBack"
                        :step="0.01"
                        prefix="$"
                        :error="errors.cash_back_amount"
                        @change="rangeChanged()"
                    />
                </AppBoxContent>


                <AppBoxContent 
                    class="my-6"
                    width="full" 
                    rounded="lg"
                    bg-class-color="bg-white" 
                    :use-min-height="false"
                    :remove-max-width="true"
                >
                    <div class="updated-loan">
                        <p class="mb-1">Your updated loan</p>
                        <div class="updated-loan-green-box rounded-lg border border-[#b4e6bd] bg-[#eaf5ec] p-4">
                            <div>
                                <p class="text-4xl"><FontBold>{{ newLoanAmount | formatMoney }}</FontBold></p>
                                <p>New loan total</p>
                            </div>
                        </div>
                        <div class="p-6">
                            <p>{{ storeData.payoff | formatMoney }} current balance</p>
                            <p>+ ${{ cashBackAmount }} cash selected</p>
                        </div>

                        <SimpleDivider />

                        <div class="flex items-center mt-2">
                            <div class="img-calendar">
                                <img src="/images/calendar.png" alt="Calendar Icon" class="inline-block mr-2" width="64">
                            </div>
                            <div>
                                <p>24-month term</p>
                                <p>Same monthly payment</p>
                            </div>
                        </div>
                    </div>

                    <div class="pt-4 text-[13px] text-[#464545]">
                        <p>Access {{ cashBackAmount | formatMoney }} today with no change to your monthly payment.</p>
                    </div>
                </AppBoxContent>
                
                <Alert type="warning" :center="true" class="mt-6">
                    Taking your extra cash will reset your progress toward your next milestone.
                </Alert>

                <div class="action-buttons text-center mt-4">
                    <div>
                        <LinkButton
                            class="mb-1"
                            href="#"
                            @click.prevent="next()"
                            type="orange">Review Updated Terms</LinkButton>
                    </div>
                    <div>
                        <LinkButton
                            :href="storeData.portalUrl"
                            type="grey">Return to Portal</LinkButton>
                    </div>
                </div>

            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import Range from '../components/Range.vue';
import AppBoxContent from '../../../../components/AppBoxContent.vue';
import FontBold from '../components/FontBold.vue';
import SimpleDivider from '../components/SimpleDivider.vue';
import Alert from '../components/Alert.vue';
import LinkButton from '../components/LinkButton.vue';
import { RefinanceStepMixin } from './../mixins/RefinanceStepMixin';
import { RefinanceFiltersMixin } from './../mixins/RefinanceFiltersMixin';
export default {
    mixins: [RefinanceStepMixin, RefinanceFiltersMixin],
    components: {
        Range,
        AppBoxContent,
        FontBold,
        SimpleDivider,
        Alert,
        LinkButton,
    },

    methods: {
        rangeChanged() {
            this.cashBackAmount = Math.max(this.minCashBack, Math.min(this.cashBackAmount, this.effectiveMaxCashBack));
        },
    },

}
</script>
